module.exports = __webpack_public_path__ + "media/images/emblems/Cham_ZG_Wappen-712876db74195f8893c7e2227d36e524.svg";